var render = function render(){var _vm=this,_c=_vm._self._c;return _c('mp-flex',{attrs:{"justify":"center","align-items":"center","gap":"0.5","width":"6","height":"6","rounded":"full","bg":"blue.100","shadow":"lg"}},_vm._l((_vm.dots),function(dot,index){return _c('mp-box',{key:index,ref:'dot' + index,refInFor:true,attrs:{"width":"2px","height":"2px","rounded":"2px","bg":"blue.700"}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }